/**
 * Store availability pickup drawer.
 * Loaded from snippets/store-availability-drawer.liquid as type="module".
 */

function init() {
  const node = document.querySelector('[data-store-availability-drawer]')
  if (!node || node.dataset.oneskinBound) return
  node.dataset.oneskinBound = 'true'

  const wash = node.parentNode.querySelector('[data-store-availability-drawer-wash]')
  const productTitleContainer = document.querySelector('[data-store-availability-product-title]')
  const variantTitleContainer = document.querySelector('[data-store-availability-variant-title]')
  const storeListContainer = node.querySelector('[data-store-list-container]')

  const lockScroll = (lock) => {
    document.body.style.overflow = lock ? 'hidden' : ''
    document.body.setAttribute('data-fluorescent-overlay-open', lock ? 'true' : 'false')
  }

  const close = () => {
    node.classList.remove('active')
    node.setAttribute('aria-hidden', 'true')
    window.setTimeout(() => lockScroll(false), 500)
  }
  const open = () => {
    node.classList.add('active')
    node.setAttribute('aria-hidden', 'false')
    lockScroll(true)
  }

  document.body.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-store-availability-drawer-trigger]')
    if (!trigger) return
    e.preventDefault()
    const parent = trigger.closest('[data-store-availability-container]')
    if (!parent) return
    const { baseUrl, variantId, productTitle, variantTitle } = parent.dataset
    fetch(`${baseUrl}/variants/${variantId}/?section_id=store-availability`)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html')
        if (productTitleContainer) productTitleContainer.innerText = productTitle
        if (variantTitleContainer) variantTitleContainer.innerText = variantTitle === 'null' ? '' : variantTitle
        const list = doc.querySelector('[data-store-availability-list-content]')
        if (storeListContainer && list) {
          storeListContainer.innerHTML = ''
          storeListContainer.appendChild(list)
        }
        open()
      })
  })
  node.addEventListener('click', (e) => {
    if (e.target.closest('[data-store-availability-close]') || e.target === wash) {
      e.preventDefault()
      close()
    }
  })
  wash?.addEventListener('click', (e) => {
    e.preventDefault()
    close()
  })
  node.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close()
  })
}

init()
